import { render } from "./vprintwriteoff.vue?vue&type=template&id=0548cf38&scoped=true"
import script from "./vprintwriteoff.vue?vue&type=script&lang=js"
export * from "./vprintwriteoff.vue?vue&type=script&lang=js"

import "./vprintwriteoff.vue?vue&type=style&index=0&id=0548cf38&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0548cf38"]])

export default __exports__